<div class="modal-backdrop scroll-hidden" >
    <div class="modal-content-custom">       
            <div>
                <div class="qwd-error-code-container mb-3">
                    <span class="qwd-error-code-shadow"></span>
                    <h1 class="qwd-error-code img">
                        <img src="assets/images/file-error.svg" />
                    </h1>

                </div>
                <h1 class="qwd-message-header">{{mainMessage}}</h1><br>
                <!-- <h2 class="qwd-error-message">{{ modalMessage }} </h2> -->
            </div>

    </div>
</div>